import React from 'react'

const ButtonSubmit = ({ config, onSubmit }) => {
  return (
    <div className={config.classContainer}>
      <div className="div-input-button">
        <input
          type='button'
          className={config.classInput}
          value={config.label}
          onClick={onSubmit}
        />
      </div>
    </div>
  )
}

export default ButtonSubmit